var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "article"
    }
  }) : _vm.notAnalyzed ? _c('div', {
    staticClass: "pa-4 text-center grey--text"
  }, [_vm._v(" Звонок ещё не проанализирован ")]) : _vm.analysis ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "mb-2"
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "dark": "",
      "color": _vm.outcomeColor
    }
  }, [_vm._v(_vm._s(_vm.outcomeText))]), _vm.analysis.durationSec ? _c('span', {
    staticClass: "ml-2 grey--text"
  }, [_vm._v(_vm._s(_vm.analysis.durationSec) + " сек.")]) : _vm._e()], 1), _vm.analysis.summary ? _c('div', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Резюме:")]), _vm._v(" " + _vm._s(_vm.analysis.summary) + " ")]) : _vm._e(), _vm.analysis.clientProblem ? _c('div', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Проблема клиента:")]), _vm._v(" " + _vm._s(_vm.analysis.clientProblem) + " ")]) : _vm._e(), _vm.analysis.outcome === 'REFUSED' && _vm.analysis.failureReason ? _c('div', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Причина отказа:")]), _vm._v(" " + _vm._s(_vm.analysis.failureReason.text) + " ")]) : _vm._e(), _vm.analysis.objections && _vm.analysis.objections.length ? _c('div', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Возражения:")]), _c('v-chip-group', {
    attrs: {
      "column": ""
    }
  }, _vm._l(_vm.analysis.objections, function (objection, i) {
    return _c('v-chip', {
      key: i,
      attrs: {
        "small": "",
        "outlined": ""
      }
    }, [_vm._v(" " + _vm._s(objection) + " ")]);
  }), 1)], 1) : _vm._e(), _c('div', {
    staticClass: "mb-2"
  }, [_c('span', {
    staticClass: "mr-4"
  }, [_vm._v(" Скрипт: "), _c('v-chip', {
    attrs: {
      "x-small": "",
      "dark": "",
      "color": _vm.$helper.aiScoreColor(_vm.analysis.scriptScore)
    }
  }, [_vm._v(_vm._s(_vm.analysis.scriptScore))])], 1), _c('span', [_vm._v(" Перспективность лида: "), _c('v-chip', {
    attrs: {
      "x-small": "",
      "dark": "",
      "color": _vm.$helper.aiScoreColor(_vm.analysis.leadQuality)
    }
  }, [_vm._v(_vm._s(_vm.analysis.leadQuality))])], 1)]), _vm.analysis.scriptIssues ? _c('div', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Замечания по скрипту:")]), _vm._v(" " + _vm._s(_vm.analysis.scriptIssues) + " ")]) : _vm._e(), _vm.analysis.transcriptText ? _c('v-expansion-panels', {
    staticClass: "mt-3",
    attrs: {
      "flat": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Расшифровка")]), _c('v-expansion-panel-content', [_c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.analysis.transcriptText))])])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }